export default __webpack_public_path__ + "static/media/business_show_2.03ee18a2.png";